import { Col, Form, Input, message, Modal, notification, Row, Select } from 'antd'
import configuration from 'modules/configuration'
import { generateMessageError, generateSelectOptions } from 'modules/core/utils'
import { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'

const NotificationRecipientCreateModal = ({
  visible,
  onClose,
  onRefetch,
  createNotificationRecipient,
  documentTypes,
  allDimensionsValuesCompany,
  allDimensionsValuesCeco,
}) => {
  const [isSaving, setIsSaving] = useState(false)
  const [form] = Form.useForm()
  const { t } = useTranslation()

  const documentTypeOptions = useMemo(
    () => generateSelectOptions({ options: Array.isArray(documentTypes) ? documentTypes : [] }),
    [documentTypes],
  )

  const companyOptions = useMemo(
    () =>
      generateSelectOptions({
        options: (allDimensionsValuesCompany || []).map((dim) => ({
          ...dim,
          id: dim.code_destination,
          name: dim.name_destination,
          code: dim.code_destination,
        })),
      }),
    [allDimensionsValuesCompany],
  )

  const cecoOptions = useMemo(
    () =>
      generateSelectOptions({
        options: (allDimensionsValuesCeco || []).map((dim) => ({
          ...dim,
          id: dim.code_destination,
          name: dim.name_destination,
          code: dim.code_destination,
        })),
      }),
    [allDimensionsValuesCeco],
  )

  const onCancel = () => {
    form.resetFields()
    onClose()
  }

  const onConfirm = () => {
    form.validateFields().then((values) => {
      setIsSaving(true)
      createNotificationRecipient(values)
        .then(() =>
          onRefetch().then(() => {
            message.success(t('FEEDBACK_CHANGES_SAVED_SUCCESS'), 8)
            setIsSaving(false)
            onCancel()
          }),
        )
        .catch((error) => {
          setIsSaving(false)
          onCancel()
          notification.error({
            message: t('FEEDBACK_DEFAULT_ERROR'),
            description: generateMessageError(error),
            duration: 0,
          })
        })
    })
  }

  return (
    <Modal
      title={t('CONFIG_NOTIFICATION_RECIPIENT_CREATE_MODAL_TITLE')}
      visible={visible}
      onCancel={onCancel}
      onOk={onConfirm}
      okText={t('ACTION_CREATE')}
      okButtonProps={{ loading: isSaving }}
      cancelButtonProps={{ disabled: isSaving }}
      centered
      forceRender
      destroyOnClose
    >
      <Form form={form} layout="vertical">
        <Row gutter={[24, 24]}>
          <Col span={12}>
            <Form.Item
              label={t('FIELD_DOCUMENT_TYPE')}
              name="document_type"
              rules={[{ required: true, message: t('REQUIRED_FIELD') }]}
            >
              <Select options={documentTypeOptions} placeholder={t('ACTION_SELECT')} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label={t('FIELD_COMPANY_CODE')}
              name="company_code"
              rules={[{ required: true, message: t('REQUIRED_FIELD') }]}
            >
              <Select options={companyOptions} placeholder={t('ACTION_SELECT')} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label={t('FIELD_COST_CENTER_CODE')}
              name="cost_center_code"
              rules={[{ required: true, message: t('REQUIRED_FIELD') }]}
            >
              <Select options={cecoOptions} placeholder={t('ACTION_SELECT')} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label={t('FIELD_EMAIL')}
              name="email"
              rules={[
                { required: true, message: t('REQUIRED_FIELD') },
                { type: 'email', message: t('FEEDBACK_INVALID_EMAIL') },
              ]}
            >
              <Input placeholder={t('FIELD_EMAIL')} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}

const mapDispatchToProps = {
  createNotificationRecipient: configuration.actions.createNotificationRecipient,
}

export default connect(null, mapDispatchToProps)(NotificationRecipientCreateModal)
